import Layout from '../components/layout'
import { getArticleByType } from '../lib/api'
import Head from 'next/head'
import Header from '../components/header'
/* import { createClient } from 'contentful' */
import Image from 'next/image'
import Link from 'next/link'
import ErrorPage  from 'next/error'

/* export async function getStatricProps(){
  const client = createClient({
    space: process.env.CONTENTFUL_SPACE_ID,
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
  })

  const res = await client.getEntries({ content_type: 'chasse' })

  return{
    props: {
      chasses:res.items
    }
  }
} */

export default function Actualites({ preview, allPosts, siteEnv}) {
  if (siteEnv != "pwafr") {
    return (<ErrorPage statusCode={404} />)
  }

  return (
    <>
      <Layout siteEnv={siteEnv}>
        <Head>
          <meta charSet="utf-8"/>
          <title>Actualités sur les Progressive web apps (PWA)</title>
          <meta name="theme-color" content="#f27b00" />
          <link href="" rel="author"/>
          <link href="" rel="canonical"/>
          <link href="" rel="amphtml"/>
          <meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no"/>
          <meta name="format-detection" content="telephone=no"/>
          <meta name="apple-mobile-web-app-capable" content="yes"/>
          <meta name="apple-mobile-web-app-status-bar-style" content="#ff7300"/>
          <meta name="description" content="Actualités sur les progressives web apps"/>
          <meta name="robots" content="index, follow"/>
          <meta property="image" content="https://progressive-web-apps.fr/fichiers/page/progressive-web-apps-fr-1.png"/>
          <meta property="og:title" content="Actualités sur les Progressive web apps (PWA)"/>
          <meta property="og:description" content="Actualités sur les progressives web apps"/>
          <meta property="og:image" content="https://progressive-web-apps.fr/fichiers/page/progressive-web-apps-fr_1200x630.png"/>
          <meta property="og:locale" content="fr"/>
          <meta property="og:site_name" content="progressive-web-apps"/>
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://progressive-web-apps.fr/actualites/"/>
          <meta property="article:tag" content=""/>
          <meta property="article:section" content="Technologie"/>
          <meta property="article:published_time" content=""/>
          <meta property="article:modified_time" content=""/>
          <meta property="article:author" content="Jonathan Rossi"/>
          <meta property="fb:app_id" content="1795695950672896"/>
          <meta name="twitter:card" content=""/>
          <meta name="twitter:site" content=""/>
          <meta name="twitter:url" content="https://progressive-web-apps.fr/actualites/"/>
          <meta name="twitter:title" content="Actualités sur les Progressive web apps (PWA)"/>
          <meta name="twitter:description" content="Actualités sur les progressives web apps"/>
          <meta name="twitter:image" content="https://progressive-web-apps.fr/fichiers/page/progressive-web-apps-fr-2.png"/>

          <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        </Head>
        <div>
          <Header />
          
          <section className="py-28 text-white text-center bg-fixed relative">
            <Image className="z-10 absolute inset-0 object-cover" layout='fill' src="/imgs/img-bg-sombre.jpg" />

            <div className="container mx-auto px-5 grid grid-cols-1 gap-4 relative z-20 bg-transparent lg:grid-cols-12">
              <div className="col-span-1 lg:col-start-3 lg:col-span-8">
                <h2 className="text-5xl leading-10 mb-3 font-light">Actualités des Progressives Web Apps</h2>
                <p className="text-base mb-4 font-light">
                    Les dernières nouvelles sur les Progressives Web Apps !
                </p>
              </div>
            </div>
          </section>

          <section>
            <div className="container mx-auto px-5 grid gap-4 grid-cols-1 relative z-20 bg-transparent lg:grid-cols-12 pb-12 pt-4">
                  
                <div className="col-span-1 lg:col-span-8 lg:col-start-3 text-center">
                    <div className="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mb-2">
                        <div className="text-small mb-4 text-gray-500 text-left">
                            <Link href="/">
                                <a className="text-color-primary">Accueil </a>
                            </Link>
                            › <Link href="/actualites">
                                <a className="text-color-primary"> Actualités </a>
                            </Link>
                        </div>
                    </div>
                </div>
              <div className="col-span-1 lg:col-span-8 lg:col-start-3 text-center">
                <div className="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mb-2">
                  {/* Cards */}
                  {allPosts?.map( (post, index) => (
                    <>
                      <div className="card-article relative overflow-hidden rounded-lg shadow-md hover:transform hover:translate-y-4" key={index}>
                        <Link href={post?.url}>
                          <a>
                            <div className="relative card-cus">
                            <Image className="object-cover w-full" layout='fill' src={post?.fbImage ? "/fichiers/page/"+post?.fbImage : "/imgs/img-bg-sombre.jpg" }/>
                              <div className="card-hover-element absolute top-0 left-0 w-full h-full bg-color-primary bg-opacity-50">
                                <span className="absolute py-1 px-2 text-color-primary bg-white">LIRE</span>
                              </div>
                            </div>

                            <div className="h-24 py-2 px-4">
                              <p className="text-xs text-gray-500 mb-2">Le {post?.dateCreation && new Date(post?.dateCreation).toLocaleDateString('fr-FR', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric',
                              })}</p>
                              <h2 className="text-sm" dangerouslySetInnerHTML={{ __html: post?.h1}}></h2>
                            </div>
                          </a>
                        </Link>
                    </div>
                    </>
                  ))}
                  
                </div>
              </div>
            </div>
          </section>
        

        </div>
      </Layout>
    </>
  )
}

export async function getStaticProps({ preview = false }) {
  const siteEnv = process.env.CONTENTFUL_SITE_TAG ?? ""
  const allPosts = (await getArticleByType("article",preview)) ?? []
  return {
    props: { 
      preview, 
      allPosts: allPosts ?? null,
      siteEnv
    },
    revalidate: 3600,
  }
}
